import type { AxiosError } from 'axios'
import { useRouterUtils } from '@/composables/use-router-utils'
import { RouterName } from '@/enums/router-name'
import { ErrorCode } from '~library/enums'

/** 檢查伺服器連線狀態，網路異常時導向維護頁 */
export function useCheckServerStatus() {
  /** 檢查伺服器連線狀態，網路異常時導向維護頁 */
  const checkServerStatus = async (error: AxiosError): Promise<boolean> => {
    const router = useRouterUtils()
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
      router.replace({
        name: RouterName.ERROR,
        params: {
          errorCode: ErrorCode.SYSTEM_MAINTAIN
        }
      })
      return false
    }

    return true
  }

  return {
    /** 檢查伺服器連線狀態，網路異常時導向維護頁 */
    checkServerStatus
  }
}
